<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">Copyright © 2013 by Shauna James Ahern and Daniel Ahern. All rights reserved.</p>
<p class="crt">Photography Copyright © 2013 by Penny De Los Santos</p>
<p class="crt">Cover design by Suzanne Sunwoo</p>
<p class="crt">Cover image by Penny De Los Santos</p>
<p class="crt">Interior design by Kara Plikaitis</p>
<p class="crt">Food styling by Karen Shinto</p>
<p class="crt">Prop styling by Anne Trenner-Mishka</p>
<p class="crt">Published by Houghton Mifflin Harcourt Publishing Company, New York, New York</p>
<p class="crt">Published simultaneously in Canada.</p>
<p class="crt">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="crt"><a class="hlink" href="http://www.hmhbooks.com" target="_blank">www.hmhbooks.com</a></p>
<p class="crt"><em>Library of Congress Cataloging-in-Publication Data</em><br/>
Ahern, Shauna James.<br/>
Gluten-free girl every day / Shauna James Ahern, with Daniel Ahern; photography by Penny De Los Santos.<br/>
<span class="crt2">p. cm.</span><br/>
<span class="crt1">ISBN 978-1-118-11521-3 (cloth); 978-0-544-18659-0 (ebk)</span><br/>
1. Gluten-free diet--Recipes. I. Ahern, Daniel, 1968- II. Title.<br/>
<span class="crt1">RM237.86.A339 2013</span><br/>
<span class="crt1">641.5’638--dc23</span><br/>
<span class="crt3">2012030520</span></p>
<p class="crt">v1.0413</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cop.vue?46922eee